/**
 * @generated SignedSource<<3a4521f52dca88491389d9ac0ead6b47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternPushStatusCardTestMutation$variables = {};
export type InternPushStatusCardTestMutation$data = {
  readonly testAzureNotificationHubConnection: {
    readonly azureApiConnected: boolean;
    readonly azureApiError: string | null;
    readonly notificationHubConnected: boolean;
    readonly notificationHubError: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"InternPushStatusCard_status">;
  };
};
export type InternPushStatusCardTestMutation = {
  response: InternPushStatusCardTestMutation$data;
  variables: InternPushStatusCardTestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "azureApiConnected",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "azureApiError",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationHubConnected",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationHubError",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InternPushStatusCardTestMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlatformPushNotificationStatus",
        "kind": "LinkedField",
        "name": "testAzureNotificationHubConnection",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternPushStatusCard_status"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InternPushStatusCardTestMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlatformPushNotificationStatus",
        "kind": "LinkedField",
        "name": "testAzureNotificationHubConnection",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationsSent30d",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pushDeliveries30d",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pushTaps30d",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tapRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRegisteredDevices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iosDevices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "androidDevices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalActiveBrands",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsWithHub",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsWithIosCredentials",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsWithAndroidCredentials",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsNeedingIosMigration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsNeedingAndroidMigration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PushNotificationDailyMetric",
            "kind": "LinkedField",
            "name": "dailyMetrics",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "date",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deliveries",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taps",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "af839a4415e0e183f15313bce890f194",
    "id": null,
    "metadata": {},
    "name": "InternPushStatusCardTestMutation",
    "operationKind": "mutation",
    "text": "mutation InternPushStatusCardTestMutation {\n  testAzureNotificationHubConnection {\n    azureApiConnected\n    azureApiError\n    notificationHubConnected\n    notificationHubError\n    ...InternPushStatusCard_status\n  }\n}\n\nfragment InternPushStatusCard_status on PlatformPushNotificationStatus {\n  azureApiConnected\n  azureApiError\n  notificationHubConnected\n  notificationHubError\n  notificationsSent30d\n  pushDeliveries30d\n  pushTaps30d\n  tapRate\n  totalRegisteredDevices\n  iosDevices\n  androidDevices\n  totalActiveBrands\n  brandsWithHub\n  brandsWithIosCredentials\n  brandsWithAndroidCredentials\n  brandsNeedingIosMigration\n  brandsNeedingAndroidMigration\n  dailyMetrics {\n    date\n    deliveries\n    taps\n  }\n}\n"
  }
};
})();

(node as any).hash = "287314bd0607fd407c3536b52e0ea2c4";

export default node;
